import {
  ADD_ALERT,
  DELETE_ALERT,
  GET_ALERTS,
  UPDATE_ALERT,
} from "./actionTypes";
import { getImage } from "store/events/selectos";

import {
  addAlertFail,
  deleteAlertFail,
  getAlertsFail,
  getAlertsSuccess,
  updateAlertFail,
} from "./actions";
import { call, put, select, takeEvery } from "redux-saga/effects";
import { addAlert, deleteAlert, getAlerts, updateAlert } from "helpers";

function* addAlertSaga({ payload: { alert } }) {
  try {
    const token = localStorage.getItem("token");
    const image = yield select(getImage);

    yield call(addAlert, token, { ...alert, image });
  } catch (error) {
    yield put(addAlertFail(error));
  }
}

function* updateAlertSaga({ payload: alert }) {
  try {
    const token = localStorage.getItem("token");
    const image = yield select(getImage);

    yield call(updateAlert, token, { ...alert, image });
  } catch (error) {
    yield put(updateAlertFail(error));
  }
}

function* getAlertsSaga({ payload: clubId }) {
  const token = localStorage.getItem("token");
  try {
    const response = yield call(getAlerts, token, clubId);
    yield put(getAlertsSuccess(response.data));
  } catch (error) {
    yield put(getAlertsFail(error));
  }
}

export function* deleteAlertSaga({ payload: id }) {
  try {
    const token = localStorage.getItem("token");
    yield call(deleteAlert, token, id);
  } catch (error) {
    yield put(deleteAlertFail(error));
  }
}

function* alertsSaga() {
  yield takeEvery(ADD_ALERT, addAlertSaga);
  yield takeEvery(UPDATE_ALERT, updateAlertSaga);
  yield takeEvery(GET_ALERTS, getAlertsSaga);
  yield takeEvery(DELETE_ALERT, deleteAlertSaga);
}

export default alertsSaga;
